import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import vaccines from './modules/vaccines'
import login from './modules/login'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        user,
        login,
        vaccines,
    },
})

export default store
